import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { checkboxData } from './checkboxData';
import './style.css';
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { invitationTtkSchema } from '../schemas';
import axios from 'axios';
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const InvitationTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false);
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [merchant, setMerchant] = useState({});

    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(`${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = res.data.data;
            const details = data[0].details;
            if (details) {
                setMerchant(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };

    useEffect(() => {
        getSingleDocumentHandler();
    }, [merchant_id, token]);

    const workingSinceOption = checkboxData.workSinceOption;
    const cardSpecialtyOption = checkboxData.cardSpecialty;
    const areaOfWorkingOption = checkboxData.areaOfWorking;

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            PiecePrice: Math.floor(merchant?.PiecePrice * currency.value) || '',
            invites: merchant?.invites || '',
            order: merchant?.order || '',
            boxed: merchant?.boxed || '',
            cardSpecialty: merchant?.cardSpecialty || [],
            areaOfWorking: merchant?.areaOfWorking || [],
            workingSince: merchant?.workingSince || [],
        },
        validationSchema: invitationTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values, PiecePrice: Math.floor(values.PiecePrice * currency.country_value) },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center' style={{ backgroundColor: '#085f9a' }}>
                                <h5>{language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <div className='table-responsive'>
                                            <table className='table text-center' style={{ border: '1px solid #fff ' }}>
                                                <tbody className='ttk_preview'>
                                                    <tr style={{ color: '#41B0FA' }}>
                                                        <th style={{ width: '25%' }}>working Since</th>
                                                        <th>Starting Price Percard(printed)</th>
                                                        <th>Unboxed Invites</th>
                                                        <th>Card Specialty</th>
                                                    </tr>
                                                    <tr>
                                                        <td>{merchant.workingSince?.map((item, index) => <p key={index}>{item.value}</p>)}</td>
                                                        <td>
                                                            <NumericFormat
                                                                value={Math.floor(
                                                                    currency.value * merchant.PiecePrice
                                                                )}
                                                                displayType="text"
                                                                thousandsGroupStyle={
                                                                    currency.symbol === "₹" ? "lakh" : "thousand"
                                                                }
                                                                thousandSeparator=","
                                                                renderText={(formattedValue) => (
                                                                    <span>
                                                                        {currency.symbol}&nbsp;{formattedValue}
                                                                    </span>
                                                                )}
                                                            />
                                                        </td>
                                                        <td>{merchant.invites}</td>
                                                        <td>{merchant.cardSpecialty?.map((item, index) => (
                                                            <span key={index}>
                                                                <i className='fa fa-check text-success' />
                                                                <span>{item.value}</span>
                                                            </span>
                                                        ))}</td>
                                                    </tr>
                                                    <tr style={{ color: '#41B0FA' }}>
                                                        <th>Service Cities</th>
                                                        <th>Minimum Order Quantity</th>
                                                        <th>Boxed Invites</th>
                                                    </tr>
                                                    <tr>
                                                        <td>{merchant.areaOfWorking?.map((item, index) => (
                                                            <span key={index}>
                                                                <i className='fa fa-check text-success' />
                                                                <span>{item.value}</span>
                                                            </span>
                                                        ))}</td>
                                                        <td>{merchant.order}</td>
                                                        <td>{merchant.boxed}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )
                                }
                                <center>
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>
                                        {merchant ? 'Make Changes' : 'Tell me more about yourself'}
                                    </button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            isMulti
                                                            options={workingSinceOption}
                                                            value={formik.values.workingSince}
                                                            onChange={(val) => formik.setFieldValue('workingSince', val)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince &&
                                                            <div className="text-danger">{formik.errors.workingSince}</div>}
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Starting Price PerCard(Printed)</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="PiecePrice"
                                                            placeholder='Per Piece Pricing'
                                                            value={formik.values.PiecePrice}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur} />
                                                    </div>
                                                    {formik.touched.PiecePrice && formik.errors.PiecePrice ? (
                                                        <div className="text-danger">{formik.errors.PiecePrice}</div>
                                                    ) : null}
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Unboxed Invites</label>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="invites"
                                                            placeholder='Unboxed Invites'
                                                            value={formik.values.invites}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.invites && formik.errors.invites &&
                                                            <div className="text-danger">{formik.errors.invites}</div>}
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Card Specialty</label>
                                                        <Select
                                                            isMulti
                                                            options={cardSpecialtyOption}
                                                            value={formik.values.cardSpecialty}
                                                            onChange={(val) => formik.setFieldValue('cardSpecialty', val)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.cardSpecialty && formik.errors.cardSpecialty &&
                                                            <div className="text-danger">{formik.errors.cardSpecialty}</div>}
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Service Cities</label>
                                                        <Select
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            value={formik.values.areaOfWorking}
                                                            onChange={(val) => formik.setFieldValue('areaOfWorking', val)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWorking && formik.errors.areaOfWorking &&
                                                            <div className="text-danger">{formik.errors.areaOfWorking}</div>}
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Minimum Order Quantity</label>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="order"
                                                            placeholder='Minimum Order Quantity'
                                                            value={formik.values.order}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.order && formik.errors.order &&
                                                            <div className="text-danger">{formik.errors.order}</div>}
                                                    </div>
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Boxed Invites</label>
                                                        <input
                                                            type='number'
                                                            className='form-control'
                                                            name="boxed"
                                                            placeholder='Boxed Invites'
                                                            value={formik.values.boxed}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.boxed && formik.errors.boxed &&
                                                            <div className="text-danger">{formik.errors.boxed}</div>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='form-group mt-3'>
                                                <button className='btn btn-primary' type='submit'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvitationTTK;